module.exports = __webpack_public_path__ + "static/media/check.da1ad053.svg";